<template>
    <div>
        <a-card title="服务调用历史">
            <search @searchChange="handleSearchChange"></search>
            <mtable :searchD="searchD" :style="{width:tableWidth}"></mtable>

        </a-card>
    </div>
</template>

<script>

import search from './search'
import mtable from './table'
export default {
    data(){
        return {
            searchD:{startTime:"",endTime:"",selectedAppcode:"",selectedType:"",selectedInvokeappcode:"",searchTimeRange:"",dateTypeTitle:''},
            tableWidth:'800px'

        }
    },
    methods:{
        handleSearchChange:function(v){
            this.searchD = v;
        },
        getTableWidth(){
            this.tableWidth = (document.body.clientWidth - 282) + 'px'
        },
       
    },
    mounted(){
        this.getTableWidth();
        window.addEventListener("resize", this.getTableWidth);
    },
    destroyed(){
        window.removeEventListener("resize", this.getTableWidth);

    },
    components:{
        search:search,
        mtable:mtable
    }
};
</script>

<style lang="less" scoped>

</style>
